import Drawer from "@mui/material/Drawer/Drawer";
import React from "react";

const DrawerComponent: React.FC<{ open: boolean; closeDrawer: any; children: any }> = ({
	open,
	closeDrawer,
	children,
}) => {
	return (
		<Drawer
			anchor="right"
			sx={{ "& .MuiBackdrop-root": { backgroundColor: "transparent" } }}
			open={open}
			onClose={closeDrawer}
		>
			{children}
		</Drawer>
	);
};

export default DrawerComponent;